import { Component, OnInit } from '@angular/core';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';

@Component({
  selector: 'app-account-profile',
  templateUrl: './account-profile.component.html',
  styleUrls: ['./account-profile.component.css']
})
export class AccountProfileComponent extends BaseClass<any> implements OnInit {

  public data:any;
  constructor(public service: WebserviceService,protected _common: CommonService) { super(document); }

  ngOnInit(): void {
    this.getData();
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData() {
    this.getServices().Get(`${this.env.baseUrl + this.api.myProfile}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.data = res.data.profile;
          this.data['available_balance'] = Number(this.data.balance) + Number(this.data.pl)
        }
      },
      (err) => {
        console.log(err);
      });
  }

  openChangePassword(e:any) {
    this._common.openModalWithComponent('', ChangePasswordComponent, 'loginModalDesign modal-dialog-centered')
  }

}
